/*global myModal */

const utilities = {
    restoreButtonState: function() {
        // Remove loading effect from button if page was restored from the bfcache
        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                $('.loading').removeClass('loading').prop('disabled', false);

                if ($('body').hasClass('modal-open')) {
                    if (_d.isMobile) {
                        myModal.forceClose();
                    } else {
                        myModal.close(0);
                    }
                }
            }
        });
    },
    formatPrice: function({price: price, dchLocale = _d.s.locale, dchCurrency = _d.s.currency}) {
        if (dchCurrency.length !== 3) {
            dchCurrency = _d.s.currency;
        }

        return new Intl.NumberFormat(dchLocale, {
            style: 'currency',
            currency: dchCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(
            price
        );
    }
};
